import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PolicyLayout({ title, eyebrow, intro, sections, footer }) {
    const { t, i18n } = useTranslation();
    const locale = i18n.resolvedLanguage || "en";
    return (
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24" data-testid="policy-page">
            <div className="border-b border-neutral-200 pb-10 mb-10">
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#0077b6] mb-3">
                    {eyebrow}
                </div>
                <h1 className="font-display text-4xl lg:text-6xl font-extrabold uppercase tracking-tighter">
                    {title}
                </h1>
                <div className="text-xs text-neutral-500 mt-4 font-mono uppercase tracking-[0.22em]">
                    {t("policy.last")} {new Date().toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" })}
                </div>
            </div>

            {intro && (
                <div className="border-l-2 border-[#00aeef] bg-[#f8f8f8]/[0.04] pl-5 pr-4 py-4 rounded-r-lg mb-12">
                    <p className="text-neutral-700 leading-relaxed">{intro}</p>
                </div>
            )}

            <div className="space-y-10">
                {sections.map((s) => (
                    <section key={s.heading}>
                        <h2 className="font-display text-xl lg:text-2xl font-bold tracking-tight text-neutral-900 mb-3">
                            {s.heading}
                        </h2>
                        {s.body.map((p) => (
                            <p key={p.slice(0, 32)} className="text-neutral-600 leading-relaxed mb-3">
                                {p}
                            </p>
                        ))}
                        {s.list && (
                            <ul className="space-y-2 mt-2 text-neutral-600">
                                {s.list.map((li) => (
                                    <li key={li.slice(0, 32)} className="flex gap-3">
                                        <span className="text-[#0077b6] mt-1">·</span>
                                        <span className="leading-relaxed">{li}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </section>
                ))}
            </div>

            {footer && (
                <div className="border-t border-neutral-200 mt-16 pt-8 text-xs text-neutral-500 leading-relaxed">
                    {footer}
                </div>
            )}

            <div className="mt-12">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-neutral-600 hover:text-black"
                    data-testid="policy-back-home"
                >
                    {t("policy.backHome")}
                </Link>
            </div>
        </div>
    );
}
